import "./TextDropdownFormatter.css";
import * as React from 'react';
import { ColorOption } from "../../inputs/DropdownInput";
import { IDropdownFormatterOption } from "../DropdownFormatter";

const PlainText = ({ text }: { text: string }) => <div
    title={text}
    className='text-dropdown-formatter overflow-text'>
    {text}
</div>

const Option = (option: IDropdownFormatterOption) => <div
    title={option.text}
    className={`text-dropdown-formatter-option overflow-text ${option.color ? 'colored' : ''}`}
    style={{ backgroundColor: option.color }}>
    <span>
        {option.text}
    </span>
</div>

const SinglechoiceFormatter = ({ option, isColored }: { option: IDropdownFormatterOption, isColored: boolean }) => isColored
    ? <div className='text-dropdown-formatter singlechoice'>
        <Option {...option} />
    </div>
    : <PlainText text={option.text} />

export const MultichoiceFormatter = ({ options, isColored }: { options: IDropdownFormatterOption[], isColored?: boolean }) => isColored
    ? <div className='text-dropdown-formatter multichoice overflow-text'>
        {options.map(_ => <Option {..._} />)}
    </div>
    : <PlainText text={options.map(_ => _.text).join(", ")} />;

export const TextDropdownFormatter = React.memo((props: { value?: string | string[], options: IDropdownFormatterOption[] }) => {
    if (!props.value) {
        return null;
    }

    const isMultiValue = Array.isArray(props.value);
    const isColored = !!props.options.find(_ => !!_.color);
    if (isMultiValue) {
        const selectedOpts = props.options.filter(opt => props.value!.includes(opt.key));
        return <MultichoiceFormatter options={selectedOpts} isColored={isColored} />;
    }

    const option = props.options.find(_ => _.key == props.value);
    if (!option) {
        return null;
    }

    return <SinglechoiceFormatter option={option} isColored={isColored} />
});

export const CardDropdownFormatter = React.memo((props: { value?: string | string[], options: IDropdownFormatterOption[] }) => {
    if (!props.value) {
        return null;
    }

    const { options, value } = props;
    const isColored = options.some(_ => !!_.color);
    const selected = getSelected(value, options);
    const title = selected.map(_ => _.text).join(", ");
    return isColored
        ? <span title={title} className="card-dropdown-formatter">
            {selected
                .map(ColorOption)
                .reduce<(JSX.Element | null)[]>((prev, curr, index, array) => {
                    if(index == 0){
                        return [...prev, curr];
                    }
                    return [...prev, <span key={index}>, </span>, curr];
                }, [])}
        </span>
        : <span title={title}>{title}</span>;
});

const getSelected = (value: string | string[], options: IDropdownFormatterOption[]) => {
    if (Array.isArray(value)) {
        return options.filter(opt => value.includes(opt.key));
    }

    const selected = options.find(_ => _.key == value);
    return selected ? [selected] : [];
}